var _style, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSimpleBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.1 41.1",
    style: {
      enableBackground: "new 0 0 59.1 41.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EBCA94;}\r\n\t.st1{fill:#0C7189;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.7,22.4c-1.3-1.7-3.3-2.8-5.6-2.8c-3.9,0-7.1,3.2-7.1,7.1s3.1,7.1,7.1,7.1h5.6h1.5v-7.1 C58.1,25.1,57.6,23.6,56.7,22.4z M55.2,26.7h-0.4h-1.7c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1c0.7,0,1.3,0.3,1.7,0.8 c0.3,0.4,0.4,0.8,0.4,1.3V26.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "K_00000025400954016292412730000008614040802157610163_",
    className: "st1",
    d: "M40.6,26.8c0-6.4,4.1-7.2,18.1-20.6 c-15,10.9-17,10.7-18.1,10.4c-1.7-0.7-3.3-10.5-3.3-10.5v11.6v16.1l14.3,7.1C51.5,41,40.6,32.9,40.6,26.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trio"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.4,1.6c-1.6,0.6-2.6,1.5-3,2.8c-0.8,2.3,0.8,5.1,0.8,5.1L34,31.8V6c0,0,0-3.2-1.9-4.8c-0.7-0.6-1.7-1-2.9-1 c-0.4,0-0.8,0-1.2,0.1l-2.1,0.5L23.4,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.6,23.3l-0.7,2.4l-0.5,2.1c-0.3,1.7,0,3.1,0.9,4c1.4,1.6,4,1.8,4.8,1.9l0,0h25.6L9.5,21c0,0-1.7-1-3.6-1 c-0.5,0-1,0.1-1.5,0.2C3.2,20.7,2.3,21.7,1.6,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,11.8c-1.1,1.3-1.5,2.6-1.2,3.9c0.5,2.4,3.2,4,3.2,4l22.2,12.9L19.8,10.4c0,0-1.6-2.8-4-3.2l0,0 c-0.2,0-0.5-0.1-0.7-0.1c-1.1,0-2.2,0.5-3.3,1.4l-1.5,1.4L8.5,11.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimpleBleu);
export default __webpack_public_path__ + "static/media/logo-simple-bleu.9cfec0c194e600a7bf514325148d0cdb.svg";
export { ForwardRef as ReactComponent };